import { computed, type ImgHTMLAttributes } from 'vue'

import { createImgSrc, getImgAltText, getImgTitle, getCropping } from './image-utils'

import type { BauerImageProps } from './bauer-image-types'

export function useImageProps (props: BauerImageProps, width: number, height: number) {
  return computed(() => {
    return getImageProps(props, width, height)
  })
}

export function getImageProps (props: BauerImageProps, width: number, height: number): ImgHTMLAttributes {
  if (!width) {
    throw new Error('Width and height are required')
  }

  const cropping = getCropping(props.image, props.srcSetDefinition)

  const imageSrc = createImgSrc(props, width, cropping)
  const imgAltText = getImgAltText(props.image, 'image')
  const imgTitle = getImgTitle(props.image, 'image')

  return {
    src: imageSrc?.toString(),
    alt: imgAltText,
    title: imgTitle,
    width,
    height
  }
}
